import React from 'react'
import PropTypes from 'prop-types'

import Align from './Align.jsx'
import Text from './Text.jsx'
import Margin from './Margin.jsx'
import useRect from '../hooks/useRect.js'

const ZeroState = ({ condition, children, placeholder, marginTop }) => {
  const [Rect] = useRect()

  if (condition) {
    return children
  }

  return (
    <Margin top={marginTop}>
      <Rect fill="#f5f5f5" rx={16} ry={16} />
      <Margin top={40}>
        <Align childrenRect={{ x: 0, y: 0, width: 700, height: 100 }}>
          <Text
            y={0}
            value={placeholder}
            width={700}
            textAnchor="middle"
            fontSize={32}
            fill="#3D3D3D"
          />
        </Align>
      </Margin>
    </Margin>
  )
}

ZeroState.propTypes = {
  condition: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  placeholder: PropTypes.string,
  marginTop: PropTypes.number,
}

ZeroState.defaultProps = {
  placeholder: 'No entities selected.',
  marginTop: 0,
}

export default ZeroState
